"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.partitionSequence = void 0;
const deep_equal_1 = __importDefault(require("deep-equal"));
/**
 * partitions a sequence based on a partition function returning {value: any; matches?: boolean}
 *  - if the function returns `matches` explicitly then adjacent matching elements will
 *    be grouped and the predicate value in the result will be from the last item in the group
 *  - if the function returns only a value then matching will be evaluated based on the deep
 *    equality of the value with its neighbors
 *
 * this is different from lodash/partition and lodash/groupBy because:
 *  - it preserves the order of the items, items will only be grouped if they are already adjacent
 *  - there can be any number of groups
 *  - it tells you the partition value
 *  - the partition value can be reduced, if you care (so you can like, partition on sequential values)
 *
 *  simple predicate:
 *    returns: [[0, [1,2]], [1, [3,4,5]]]
 *    partitionSequence((n: number) => ({value: Math.floor(n / 3)}), [1,2,3,4,5])
 *
 *  mutating partition:
 *    returns: [
 *      [{min: 1,max: 3}, [1,2,3]],
 *      [{min: 5,max: 6}, [5,6]],
 *      [{min: 8,max: 8}, [8]],
 *    ]
 *    partitionSequence(
 *      (n: number, p?: {min: number; max: number}) =>
 *        p && p.max + 1 === n
 *          ? {value: {...p, max: n}, matches: true}
 *          : {value: {min: n, max: n}, matches: false}
 *      , [1,2,3,5,6,8]
 *    )
 */
const partitionSequence = (getPartition, sequence) => {
    const appendItem = (result, item) => {
        const current = result[result.length - 1];
        const itemPartition = getPartition(item, current === null || current === void 0 ? void 0 : current[0]);
        if (current && ((itemPartition.matches === undefined && (0, deep_equal_1.default)(current[0], itemPartition.value))
            || itemPartition.matches)) {
            current[0] = itemPartition.value;
            current[1].push(item);
        }
        else {
            result.push([itemPartition.value, [item]]);
        }
        return result;
    };
    return sequence.reduce(appendItem, []);
};
exports.partitionSequence = partitionSequence;
